import script from "./LocationGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocationGrid.vue?vue&type=script&setup=true&lang=ts"

import "./LocationGrid.vue?vue&type=style&index=0&id=82b12a24&lang=scss"

const __exports__ = script;

export default __exports__